import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import Logo from "./Logo";

const SITEMAP = [
  { to: "/services", label: "Services" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/insights", label: "Insights" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const SERVICES = [
  "Digital Acquisition Funnels & SEO",
  "AI Automation & Salesforce CRM",
  "Commercial Market Assessment",
];

export default function Footer() {
  return (
    <footer className="relative border-t hairline bg-surface/30" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-10 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-500">
              Digital acquisition funnels, AI-assisted Salesforce CRM pipelines and commercial
              market intelligence — engineered for European SMEs, tech distributors and
              enterprise brands.
            </p>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.34em] text-neon/70">
              Growth, engineered.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Sitemap</p>
            <ul className="mt-5 space-y-3">
              {SITEMAP.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-slate-600 transition-colors hover:text-neon" data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Capabilities</p>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s} className="text-sm text-slate-500">{s}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Contact</p>
            <div className="mt-5 space-y-3">
              <a href="mailto:aadibanerjee@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-neon">
                <Mail className="h-4 w-4 text-neon/70" /> aadibanerjee@gmail.com
              </a>
              <Link to="/contact" data-testid="footer-cta-link" className="mt-2 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-neon">
                Start a conversation <ArrowUpRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t hairline pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500">
            © 2026 Vector Growth and Advisory
          </p>
          <div className="flex flex-wrap items-center gap-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-600">
              Digital Acquisition · AI Automation · Market Intelligence
            </p>
            <Link to="/admin" data-testid="footer-admin-link" className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-600 transition-colors hover:text-neon">
              Owner login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
